import { useState } from "react";
import axios from "axios";
import { Store, Send } from "lucide-react";
import { formatApiErrorDetail } from "../../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FranchiseSection = () => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    city: "",
    note: "",
  });
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", msg: "" });
    setLoading(true);
    try {
      await axios.post(`${API}/franchise-applications`, form);
      setStatus({
        type: "success",
        msg: "Bayilik başvurunuz alındı! Ekibimiz en kısa sürede sizinle iletişime geçecek.",
      });
      setForm({ name: "", phone: "", email: "", city: "", note: "" });
    } catch (err) {
      setStatus({
        type: "error",
        msg: formatApiErrorDetail(err.response?.data?.detail) || err.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "mt-2 w-full border-2 border-[#1A1A1A] bg-white px-4 py-3 text-sm font-medium text-[#1A1A1A] outline-none focus:shadow-[3px_3px_0_0_#1A1A1A]";

  return (
    <section
      id="bayilik"
      data-testid="franchise-section"
      className="border-y-2 border-[#1A1A1A] bg-[#1A1A1A] py-16 md:py-24"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 md:grid-cols-2 md:px-8">
        <div className="flex flex-col justify-center">
          <p className="font-script text-2xl text-[#E63946] md:text-3xl">
            Bayilik
          </p>
          <h2 className="mt-2 text-4xl font-black uppercase tracking-tighter text-white sm:text-5xl">
            Kendi Deny'S'ini
            <br />
            açmak ister misin?
          </h2>
          <p className="mt-4 max-w-md text-base font-medium text-[#C9C9C9]">
            Büyüyen bir lezzet hikâyesinin parçası ol. Şehrini yaz, bayilik
            detayları için biz seni arayalım.
          </p>
          <ul className="mt-8 space-y-3 text-sm font-bold uppercase tracking-wide text-white">
            <li className="flex items-center gap-3">
              <Store size={18} strokeWidth={2.5} className="text-[#E63946]" />
              Kanıtlanmış iş modeli
            </li>
            <li className="flex items-center gap-3">
              <Store size={18} strokeWidth={2.5} className="text-[#E63946]" />
              Eğitim ve açılış desteği
            </li>
            <li className="flex items-center gap-3">
              <Store size={18} strokeWidth={2.5} className="text-[#E63946]" />
              Tedarik ve marka desteği
            </li>
          </ul>
        </div>

        <form
          onSubmit={handleSubmit}
          data-testid="franchise-form"
          className="card-print p-6 md:p-8"
        >
          <div className="space-y-5">
            <div>
              <label htmlFor="franchise-name" className="text-xs font-bold uppercase tracking-wide text-[#1A1A1A]">
                Ad Soyad
              </label>
              <input
                id="franchise-name"
                data-testid="franchise-name-input"
                type="text"
                required
                value={form.name}
                onChange={handleChange("name")}
                className={inputCls}
                placeholder="Adınız Soyadınız"
              />
            </div>
            <div>
              <label htmlFor="franchise-phone" className="text-xs font-bold uppercase tracking-wide text-[#1A1A1A]">
                Telefon
              </label>
              <input
                id="franchise-phone"
                data-testid="franchise-phone-input"
                type="tel"
                required
                value={form.phone}
                onChange={handleChange("phone")}
                className={inputCls}
                placeholder="05XX XXX XX XX"
              />
            </div>
            <div>
              <label htmlFor="franchise-email" className="text-xs font-bold uppercase tracking-wide text-[#1A1A1A]">
                E-posta
              </label>
              <input
                id="franchise-email"
                data-testid="franchise-email-input"
                type="email"
                required
                value={form.email}
                onChange={handleChange("email")}
                className={inputCls}
                placeholder="ornek@eposta.com"
              />
            </div>
            <div>
              <label htmlFor="franchise-city" className="text-xs font-bold uppercase tracking-wide text-[#1A1A1A]">
                Şube Açmak İstediğiniz Şehir
              </label>
              <input
                id="franchise-city"
                data-testid="franchise-city-input"
                type="text"
                required
                value={form.city}
                onChange={handleChange("city")}
                className={inputCls}
                placeholder="Örn: Samsun"
              />
            </div>
            <div>
              <label htmlFor="franchise-note" className="text-xs font-bold uppercase tracking-wide text-[#1A1A1A]">
                Not (isteğe bağlı)
              </label>
              <textarea
                id="franchise-note"
                data-testid="franchise-note-input"
                rows={3}
                value={form.note}
                onChange={handleChange("note")}
                className={inputCls}
                placeholder="Deneyiminiz, yatırım planınız..."
              />
            </div>

            {status.msg && (
              <div
                data-testid={
                  status.type === "success"
                    ? "franchise-success-message"
                    : "franchise-error-message"
                }
                className={`border-2 px-4 py-3 text-sm font-bold ${
                  status.type === "success"
                    ? "border-[#1A7A3D] bg-[#1A7A3D]/10 text-[#1A7A3D]"
                    : "border-[#E63946] bg-[#E63946]/10 text-[#E63946]"
                }`}
              >
                {status.msg}
              </div>
            )}

            <button
              data-testid="franchise-submit-button"
              type="submit"
              disabled={loading}
              className="btn-chunky w-full justify-center bg-[#E63946] px-6 py-3 text-base uppercase tracking-wide text-white disabled:opacity-60"
            >
              <Send size={18} strokeWidth={2.5} />
              {loading ? "Gönderiliyor..." : "Bayilik Başvurusu Gönder"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};
